import { memo, useRef } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import Pin from '@Components/Pin';
import styles from './ProductImage.module.css';

import type { FC } from 'react';
import type { ProductData } from '@Types/Product';
import type { MediaGalleryItem } from '@Pages/PageProduct/typings';

export interface ProductImageProps {
  className?: string;
  img: MediaGalleryItem;
  products?: ProductData[];
  size: 's' | 'm';
  loading?: 'lazy' | 'eager';
  productId: number;
  onClickImage?: () => void;
}

const ProductImage: FC<ProductImageProps> = (props) => {
  const { img, onClickImage, products, size, loading, className, productId, ...restProps } = props;
  const refGrid = useRef<HTMLDivElement>(null);

  return (
    <div
      {...restProps}
      className={cn(
        styles.imageWrapper,
        {
          [styles.sizeS]: size === 's',
          [styles.sizeM]: size === 'm',
        },
        className,
      )}
      ref={refGrid}
    >
      <Img
        itemProp='image'
        key={img.title}
        className={cn(styles.image, styles.landscape)}
        cnImage={styles.cnImage}
        src={img.image}
        alt={img.alt}
        title={img.alt}
        onClick={onClickImage}
        loading={loading}
      />
      {products && img.products && (
        <>
          {img.products.map((product, productIndex) => {
            const productForPin = products.find((elem) => elem.id === product.id);

            if (productForPin) {
              return (
                <Pin
                  key={productIndex}
                  pinCoords={[product.marker.x, product.marker.y]}
                  product={productForPin}
                  refGrid={refGrid}
                  analyticsTitle={`${productId} карточка точки`}
                  analyticsLabel='Листинг'
                  inNewTab
                />
              );
            }
          })}
        </>
      )}
    </div>
  );
};

export default memo(ProductImage);
